
export function getChannelIcon(channel: string): string {
  // Function to get the icon for the channel type
  if (channel) {
    switch (channel) {
      case 'Web':
        return 'feather/monitor';
      case 'MobileApp':
        return 'feather/smartphone';
      case 'Chatbot':
        //return 'feather/message-circle';
        return 'feather/bot';
      case 'IVR':
        return 'feather/phone-call';
      case 'CSR':
        return 'feather/headphones';
      case 'Proactive':
        return 'feather/code-2';
      case 'Unknown':
        return 'feather/help-circle';
      default:
        return 'feather/help-circle';
    }
  } else {
    return 'feather/help-circle';
  }
}
